import {BulkRecommendationType, BulkUpdateType} from 'src/utils/bulkUpdateUtils';
import {ECMActionType, ProtectionMenuNameOptions, WebFilteringSubMenu} from '../utils/enums';

export enum BronzeTabName {
    DEVICES = 'devices',
    IP_EXCEPTIONS = 'ipExceptions',
    DOMAINS = 'domains',
    CATEGORIES = 'categories',
    REPORTS = 'reports',
}

export enum EmailLinkSource {
    NONE = 'none',
    RECOMMEND_APP = 'recommendApp',
    RECOMMENDATION_ML = 'recommendationML',
    SEVEN_DAYS_NO_APPLY = 'sevenDaysNoApply',
}

export enum EventType {
    UnknownError = 'Unknown_Error',
    ApplyPolicy = 'Policy_Apply',
    ActiveVersionChanged = 'Policy_Activate',
    DraftVersionCreated = 'Policy_CreateDraft',
    UpdateVersion = 'Policy_Update',

    ActivityLogsExport = 'ActivityLogs_Export',
    LogsExport = 'Logs_Export',
    MultipleLogsExport = 'MultipleLogs_Export',
    ReportsExport = 'Reports_Export',

    LogsLoad = 'Logs_Load',
    ActivityLogsLoad = 'ActivityLogs_Load',

    UnAuthenticated = 'User_Unauthenticated',
    UnAuthorized = 'UnAuthorized',
    LogOut = 'User_LogOut',

    CustomerSignIn = 'Customer_SignIn',
    CustomerSignOut = 'Customer_SignOut',
    PageView = 'Page_View',
    LinkClicked = 'Link_Clicked',

    ConnectionSelected = 'Connection_Selected',
    PolicySelected = 'Policy_Selected',

    ChatOpen = 'Chat_open',
    ChatClose = 'Chat_close',
    ChatSend = 'Chat_send',
    ChatMessageReceived = 'Chat_message_received',
    ChatActionButtonClick = 'Chat_how_can_i_help_click',
    ModalView = 'Modal_View'
}

export const policyActionsLocationMap: {[key in ECMActionType]: string} = {
    [ECMActionType.QuickStart]: 'quickPolicyModal',
    [ECMActionType.SmartPolicy]: 'smartPolicyModal',
    [ECMActionType.PullFromExisting]: 'pullPolicyModal',
};

export type ProtectionNameAnalytic = ProtectionMenuNameOptions | WebFilteringSubMenu | BulkUpdateType | BulkRecommendationType;